import React from "react";
import DownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ReactComponent as Copy } from "../../../assets/icons/copy.svg";
import { ReactComponent as Delete } from "../../../assets/icons/trash.svg";
import { activeQuestions } from "../../../constants/zones";
import { useTranslation } from "react-i18next";
const SettingsCard = ({
  questions = [],
  activeQuestion,
  hoverQuestion,
  rangeData,
  dimensions,
  cod,
  protection,
  data,
  setData,
  setDimensions,
  setCod,
  setProtection,
  expandDropdown,
  setExpandDropdown,
  setRangeData,
  rangeDropdown,
  setRangeDropdown,
}) => {
  const { t } = useTranslation("carrier");
  const handleUnitChange = (quest_id, unit) => {
    setData((d) =>
      d.map((itm) => {
        return itm.question_id === quest_id ? { ...itm, unit } : itm;
      })
    );
  };

  const handleCarrierType = (quest_id, type) => {
    setData((d) =>
      d.map((itm) => {
        return String(itm.question_id) === String(quest_id)
          ? { ...itm, type }
          : itm;
      })
    );
    setExpandDropdown(false);
  };
  // Refactored: Add new range to the correct question's rangeData in data
  const handleAddRangeData = (questionId) => {
    setData((prevData) =>
      prevData.map((item) => {
        if (String(item.question_id) === String(questionId)) {
          const rng = item.rangeData[item.rangeData.length - 1];
          const newRange = {
            ...rng,
            min: Number(rng.max) + 1,
            max:
              Number(rng.min) === 0
                ? Number(rng.max) + (Number(rng.max) - Number(rng.min))
                : Number(rng.max) + (Number(rng.max) - Number(rng.min)) + 1,
          };
          return {
            ...item,
            rangeData: [...item.rangeData, newRange],
          };
        }
        return item;
      })
    );
  };

  // Refactored: Remove range from the correct question's rangeData in data
  const handleRemoveRangeData = (questionId, index) => {
    setData((prevData) =>
      prevData.map((item) => {
        if (String(item.question_id) === String(questionId)) {
          return {
            ...item,
            rangeData: item.rangeData.filter((_, ind) => index !== ind),
          };
        }
        return item;
      })
    );
  };

  // Refactored: Add new dimension to the correct question's dimensions in data
  const handleAddDimension = (questionId) => {
    setData((prevData) =>
      prevData.map((item) => {
        if (String(item.question_id) === String(questionId)) {
          const rng = item.dimensions[item.dimensions.length - 1];
          const newDim = {
            ...rng,
            min_width: Number(rng.max_width) + 1,
            min_length: Number(rng.max_length) + 1,
            min_height: Number(rng.max_height) + 1,
            max_width:
              Number(rng.max_width) +
              (Number(rng.max_width) - Number(rng.min_width)) +
              1,
            max_length:
              Number(rng.max_length) +
              (Number(rng.max_length) - Number(rng.min_length)) +
              1,
            max_height:
              Number(rng.max_height) +
              (Number(rng.max_height) - Number(rng.min_height)) +
              1,
          };
          return {
            ...item,
            dimensions: [...item.dimensions, newDim],
          };
        }
        return item;
      })
    );
  };

  // Refactored: Remove dimension from the correct question's dimensions in data
  const handleRemoveDimension = (questionId, index) => {
    setData((prevData) =>
      prevData.map((item) => {
        if (String(item.question_id) === String(questionId)) {
          return {
            ...item,
            dimensions: item.dimensions.filter((_, ind) => index !== ind),
          };
        }
        return item;
      })
    );
  };

  // Refactored: Change dimension values in the correct question's dimensions in data
  const handleDimensionChange = (questionId, e, index) => {
    setData((prevData) =>
      prevData.map((item) => {
        if (String(item.question_id) === String(questionId)) {
          return {
            ...item,
            dimensions: item.dimensions.map((itm, idx) =>
              index === idx ? { ...itm, [e.target.name]: e.target.value } : itm
            ),
          };
        }
        return item;
      })
    );
  };

  // Handler to change range values in the correct question's rangeData in data
  const handleRangeDataChange = (questionId, e, index) => {
    setData((prevData) =>
      prevData.map((item) => {
        if (String(item.question_id) === String(questionId)) {
          return {
            ...item,
            rangeData: item.rangeData.map((rng, idx) =>
              index === idx ? { ...rng, [e.target.name]: e.target.value } : rng
            ),
          };
        }
        return item;
      })
    );
  };

  const handleCodChange = (e, index) => {
    setCod((dim) => {
      return dim.map((itm, idx) => {
        return index === idx
          ? { ...itm, [e.target.name]: e.target.value }
          : itm;
      });
    });
  };
  const handleProtectionChange = (e, index) => {
    setProtection((dim) => {
      return dim.map((itm, idx) => {
        return index === idx
          ? { ...itm, [e.target.name]: e.target.value }
          : itm;
      });
    });
  };

  return (
    <div className="zstc_col_settings">
      <div className="zstc_col_heading">{t("zoneSettings.settings")}</div>
      {questions?.map((item, index) => {
        const currentData = data?.find(
          (d) => String(d.question_id) === String(item.id)
        );
        return (
          <div
            className={`zstc_colset_data ${
              activeQuestions.includes(item.id)
                ? ""
                : "pointer-events-none opacity-30 select-none cursor-not-allowed"
            }`}
            style={{
              minHeight:
                item.type === "weight"
                  ? `${currentData?.rangeData?.length * 50 || 50}px`
                  : item.type === "size"
                  ? `${currentData?.dimensions?.length * 50 || 50}px`
                  : "50px",
            }}
          >
            <div
              className={`zstc_col_settingsdata ${
                ["number", "time_range"].includes(item.type) ? "invisible" : ""
              }`}
            >
              <div className="zstc_col_settingsdataunits">
                {item.units.map((unit, idx) => (
                  <div
                    className={`zstc_col_settingsdataunit ${
                      currentData?.unit === unit &&
                      "zstc_col_settingsdataunitactive"
                    } ${
                      (item.id === activeQuestion ||
                        item.id === hoverQuestion) &&
                      "active__question_setfield"
                    }`}
                    onClick={() => handleUnitChange(item.id, unit)}
                  >
                    {unit}
                  </div>
                ))}
              </div>
              <div
                className={`zs_dropdown_wrap ${
                  (item.id === activeQuestion || item.id === hoverQuestion) &&
                  "active__question_setfield"
                }`}
              >
                <div className="zszone_select_wrap">
                  <div
                    className="zszone_select_value"
                    onClick={() =>
                      setExpandDropdown(
                        expandDropdown === item.id ? false : item.id
                      )
                    }
                  >
                    {currentData?.type}
                  </div>

                  <DownIcon
                    className="zszone_select_icon"
                    onClick={() =>
                      setExpandDropdown(
                        expandDropdown === item.id ? false : item.id
                      )
                    }
                  />
                  {expandDropdown === item.id && (
                    <div className="zs_zone_options_list">
                      <div
                        className="zs_zone_option"
                        onClick={() => handleCarrierType(item.id, "package")}
                      >
                        {t("zoneSettings.package")}
                      </div>
                      <div
                        className="zs_zone_option"
                        onClick={() => handleCarrierType(item.id, "shipment")}
                      >
                        {t("zoneSettings.shipment")}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {item.type === "weight" && (
                <div className="zs_rangedata_list">
                  {currentData?.rangeData?.map((rng, idx) => (
                    <div className="zs_rangedata_wrap">
                      <input
                        type="text"
                        className={`zs_rangedata_input ${
                          (item.id === activeQuestion ||
                            item.id === hoverQuestion) &&
                          "active__question_setfield"
                        }`}
                        name="min"
                        value={rng.min}
                        onChange={(e) => {
                          handleRangeDataChange(item.id, e, idx);
                        }}
                      />
                      <span className="zs_rangedata_to">{t("zoneSettings.to")}</span>
                      <input
                        type="text"
                        className={`zs_rangedata_input ${
                          (item.id === activeQuestion ||
                            item.id === hoverQuestion) &&
                          "active__question_setfield"
                        }`}
                        name="max"
                        value={rng.max}
                        onChange={(e) => {
                          handleRangeDataChange(item.id, e, idx);
                        }}
                      />
                      <Copy
                        className="zs_rangedata_copy"
                        onClick={() => handleAddRangeData(item.id)}
                      />
                      {idx > 0 && (
                        <Delete
                          className="zs_rangedata_delete"
                          onClick={() => handleRemoveRangeData(item.id, idx)}
                        />
                      )}
                      {idx < 1 && (
                        <div className="zs_rangedata_deleteplaceholder"></div>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {["size", "cod", "protection"].includes(item.type) && (
                <div
                  className={`zs_dropdown_wrap ${
                    (item.id === activeQuestion || item.id === hoverQuestion) &&
                    "active__question_setfield"
                  }`}
                >
                  <div className="zszone_select_wrap">
                    <div
                      className="zszone_select_value"
                      onClick={() =>
                        setRangeDropdown(
                          rangeDropdown === item.id ? false : item.id
                        )
                      }
                    >
                      {t("zoneSettings.range")}
                    </div>

                    <DownIcon
                      className="zszone_select_icon"
                      onClick={() =>
                        setRangeDropdown(
                          rangeDropdown === item.id ? false : item.id
                        )
                      }
                    />
                    {rangeDropdown === item.id && (
                      <div className="zs_zone_options_list">
                        <div className="zs_zone_option">{t("zoneSettings.range")}</div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            {item.type === "size" &&
              currentData?.dimensions?.map((dimension, indx) => (
                <div className="zstcc_settings_dimensionsdata">
                  <div className="zstcc_settings_dimensionsdataleft">
                    <div className="zstccsddl_dimension_item mr-1">
                      <div className="zstccsddl_dimension_itemtop text-xs">
                        <span>{t("zoneSettings.length")}</span>
                        <span>{t("zoneSettings.width")}</span>
                        <span>{t("zoneSettings.height")}</span>
                      </div>
                      <div className="zstccsddl_dimension_itembottom">
                        <input
                          type="text"
                          className={`zs_rangedata_input ${
                            (item.id === activeQuestion ||
                              item.id === hoverQuestion) &&
                            "active__question_setfield"
                          }`}
                          name="min_length"
                          onChange={(e) =>
                            handleDimensionChange(item.id, e, indx)
                          }
                          value={dimension.min_length}
                        />
                        <input
                          type="text"
                          className={`zs_rangedata_input ${
                            (item.id === activeQuestion ||
                              item.id === hoverQuestion) &&
                            "active__question_setfield"
                          }`}
                          onChange={(e) =>
                            handleDimensionChange(item.id, e, indx)
                          }
                          name="min_width"
                          value={dimension.min_width}
                        />
                        <input
                          type="text"
                          className={`zs_rangedata_input ${
                            (item.id === activeQuestion ||
                              item.id === hoverQuestion) &&
                            "active__question_setfield"
                          }`}
                          onChange={(e) =>
                            handleDimensionChange(item.id, e, indx)
                          }
                          name="min_height"
                          value={dimension.min_height}
                        />
                      </div>
                    </div>
                    <span className="zstccsddl_dimension_middletext min-w-[18px]">
                      {t("zoneSettings.to")}
                    </span>
                    <div className="zstccsddl_dimension_item mx-2">
                      <div className="zstccsddl_dimension_itemtop text-xs">
                        <span>{t("zoneSettings.length")}</span>
                        <span>{t("zoneSettings.width")}</span>
                        <span>{t("zoneSettings.height")}</span>
                      </div>
                      <div className="zstccsddl_dimension_itembottom">
                        <input
                          type="text"
                          className={`zs_rangedata_input ${
                            (item.id === activeQuestion ||
                              item.id === hoverQuestion) &&
                            "active__question_setfield"
                          }`}
                          onChange={(e) =>
                            handleDimensionChange(item.id, e, indx)
                          }
                          name="max_length"
                          value={dimension.max_length}
                        />
                        <input
                          type="text"
                          className={`zs_rangedata_input ${
                            (item.id === activeQuestion ||
                              item.id === hoverQuestion) &&
                            "active__question_setfield"
                          }`}
                          onChange={(e) =>
                            handleDimensionChange(item.id, e, indx)
                          }
                          name="max_width"
                          value={dimension.max_width}
                        />
                        <input
                          type="text"
                          className={`zs_rangedata_input ${
                            (item.id === activeQuestion ||
                              item.id === hoverQuestion) &&
                            "active__question_setfield"
                          }`}
                          onChange={(e) =>
                            handleDimensionChange(item.id, e, indx)
                          }
                          name="max_height"
                          value={dimension.max_height}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="zstcc_settings_dimensionsdataright">
                    <Copy onClick={() => handleAddDimension(item.id)} />
                    {indx > 0 && (
                      <Delete
                        onClick={() => handleRemoveDimension(item.id, indx)}
                      />
                    )}
                    {indx < 1 && (
                      <div className="zs_rangedata_deleteplaceholder"></div>
                    )}
                  </div>
                </div>
              ))}
            {item.type === "cod" &&
              cod.map((codItem, indx) => (
                <div className="zstcc_settings_coddata">
                  <div className="zstcc_settings_coddataleft">
                    <input
                      type="text"
                      className={`zs_coddata_input ${
                        (item.id === activeQuestion ||
                          item.id === hoverQuestion) &&
                        "active__question_setfield"
                      }`}
                      name="min"
                      value={codItem.min}
                      onChange={(e) => handleCodChange(e, indx)}
                    />
                    <span>{t("zoneSettings.to")}</span>
                    <input
                      type="text"
                      className={`zs_coddata_input ${
                        (item.id === activeQuestion ||
                          item.id === hoverQuestion) &&
                        "active__question_setfield"
                      }`}
                      name="max"
                      value={codItem.max}
                      onChange={(e) => handleCodChange(e, indx)}
                    />
                  </div>
                </div>
              ))}
            {item.type === "protection" &&
              protection.map((protectionItem, indx) => (
                <div className="zstcc_settings_coddata">
                  <div className="zstcc_settings_coddataleft">
                    <input
                      type="text"
                      className={`zs_coddata_input ${
                        (item.id === activeQuestion ||
                          item.id === hoverQuestion) &&
                        "active__question_setfield"
                      }`}
                      name="min"
                      value={protectionItem.min}
                      onChange={(e) => handleProtectionChange(e, indx)}
                    />
                    <span>{t("zoneSettings.to")}</span>
                    <input
                      type="text"
                      className={`zs_coddata_input ${
                        (item.id === activeQuestion ||
                          item.id === hoverQuestion) &&
                        "active__question_setfield"
                      }`}
                      name="max"
                      value={protectionItem.max}
                      onChange={(e) => handleProtectionChange(e, indx)}
                    />
                  </div>
                </div>
              ))}
          </div>
        );
      })}
    </div>
  );
};

export default SettingsCard;
